(function ($) {
	/* When button menu is clicked, add class to nav conatiner and display overlay menu*/
	// When linked is clicked
	$(".link--menu[data-menu='closed']").on("click", function (e) {
		$(this).addClass("open");
		$(".overlay-menu-container").addClass("open");
		$(".overlay-menu-container .overlay-menu-menu").addClass("open");
		// Add class to body to disable scroll
		$("body").addClass("fixed-body");
	});
	$(".link--menu[data-menu='opened']").on("click", function (e) {
		$(this).removeClass("open");
		$(".overlay-menu-container").removeClass("open");
		$(".overlay-menu-container .overlay-menu-menu").removeClass("open");
		// Remove class to body to enable scroll
		$("body").removeClass("fixed-body");
	});
})(jQuery);
